import { on } from 'delegated-events'
import throttle from 'lodash/throttle'
import Swiper, { Controller, Navigation } from 'swiper'

Swiper.use([Controller, Navigation])

const headerNode = document.querySelector('.comparison-header')
const gridNode = document.querySelector('.comparison-grid')
const gridContainer = document.querySelector('.comparison-grid-container')
const gridSidebar = document.querySelector('.comparison-sidebar')

let numSlides = 0
let mainSwiper = null
let gridSwiper = null

const fn = {
  init: () => {
    fn.setupSliders()

    on('change', '[name="filters"]', fn.handleFilters)
    on('click', '.comparison-dropdown-toggle', fn.handleFilterDropdown)

    window.addEventListener(
      'resize',
      throttle(() => {
        fn.adjustCellHeights()
        fn.handleControls()
        fn.positionGrid()
      }, 250)
    )

    document.body.addEventListener('click', (e) => {
      if (!e.target.closest('.comparison-dropdown')) {
        const dropdown = document.querySelector('.comparison-dropdown')

        if (dropdown) {
          dropdown.classList.remove('is-active')
        }
      }
    })

    fn.handleControls()
  },

  setupSliders: () => {
    const headerContainer = headerNode.querySelector('.swiper')
    const gridContainer = gridNode.querySelector('.swiper')

    numSlides = headerContainer.querySelectorAll('.swiper-slide').length

    if (numSlides > 1) {
      gridSwiper = new Swiper(gridContainer, {
        slidesPerView: 'auto',
        on: {
          init: () => {
            fn.adjustCellHeights(), fn.positionGrid()
          },
          update: () => {
            fn.adjustCellHeights(), fn.positionGrid()
          },
        },
      })

      const headerSwiper = new Swiper(headerContainer, {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        on: {
          init: fn.adjustCellHeights,
        },
        controller: {
          control: gridSwiper,
        },
        navigation: {
          nextEl: headerNode.querySelector('.comparison-button-next'),
          prevEl: headerNode.querySelector('.comparison-button-prev'),
        },
      })

      mainSwiper = headerSwiper
    }
  },

  positionGrid: () => {
    const containerWidth = gridContainer.clientWidth
    const sidebarWidth = gridSidebar.clientWidth
    const gridWidth = containerWidth - sidebarWidth
    const numSlides = headerNode.querySelectorAll('.swiper .swiper-slide:not(.is-hidden)').length
    let totalWidth = 0

    if (window.matchMedia('(max-width: 767px)').matches) {
      gridContainer.style.left = null
      return
    }

    if (window.matchMedia('(min-width: 1280px)').matches) {
      totalWidth = sidebarWidth + numSlides * (gridWidth * (1 / 7))
    } else if (window.matchMedia('(min-width: 1024px)').matches) {
      totalWidth = sidebarWidth + numSlides * (gridWidth * (1 / 5))
    } else if (window.matchMedia('(min-width: 768px)').matches) {
      totalWidth = sidebarWidth + numSlides * (gridWidth * (1 / 4))
    }

    if (totalWidth >= window.innerWidth) {
      gridContainer.style.left = null
    } else {
      gridContainer.style.left = `calc(50% - ${Math.abs(totalWidth / 2)}px`
    }
  },

  handleFilters: () => {
    const all = Array.from(document.querySelectorAll('[name=filters]')).map((x) => x.value)
    const selected = Array.from(document.querySelectorAll('[name=filters]:checked')).map((x) => x.value)
    const unselected = Array.from(document.querySelectorAll('[name=filters]:not(:checked)')).map((x) => x.value)

    selected.forEach((id) => {
      document.querySelectorAll(`.swiper-slide[data-id="${id}"]`).forEach((x) => {
        x.style.display = null
        x.classList.remove('is-hidden')
      })
    })

    unselected.forEach((id) => {
      document.querySelectorAll(`.swiper-slide[data-id="${id}"]`).forEach((x) => {
        x.style.display = 'none'
        x.classList.add('is-hidden')
      })
    })

    if (selected.length === 0) {
      all.forEach((id) => {
        document.querySelectorAll(`.swiper-slide[data-id="${id}"]`).forEach((x) => {
          x.style.display = null
          x.classList.remove('is-hidden')
        })
      })
    }

    mainSwiper.update()
    gridSwiper.update()
  },

  handleFilterDropdown: (e) => {
    e.target.closest('.comparison-dropdown').classList.toggle('is-active')
  },

  adjustCellHeights: () => {
    const gridNumRows = gridNode.dataset.rowCount + 1

    const titleCells = Array.from(document.querySelectorAll('.comparison-item-title'))

    let maxTitleHeight = Math.ceil(Math.max(...titleCells.filter((x) => x.offsetHeight > 0).map((x) => x.offsetHeight)))

    if (window.matchMedia('(min-width: 768px)').matches) {
      maxTitleHeight = 0
    }

    for (let i = 0; i < gridNumRows; i++) {
      const gridCells = Array.from(gridNode.querySelectorAll(`.comparison-cell[data-row-index="${i}"]`))

      gridCells.filter((x) => !x.classList.contains('swiper-slide-duplicate')).forEach((x) => (x.style.height = null))

      const maxCellHeight = Math.ceil(
        Math.max(...gridCells.filter((x) => !x.classList.contains('swiper-slide-duplicate')).map((x) => x.offsetHeight))
      )

      gridCells.forEach((x) => {
        x.style.height = `${maxCellHeight + maxTitleHeight}px`

        const value = x.querySelector('.comparison-cell-value')

        if (value) {
          if (window.matchMedia('(min-width: 768px)').matches) {
            value.style.paddingTop = null
          } else {
            value.style.paddingTop = `${maxTitleHeight}px`
          }
        }
      })
    }

    gridNode.classList.remove('invisible')

    const headerCells = Array.from(headerNode.querySelectorAll('.comparison-cell[data-row-index="1"]'))

    const maxHeaderHeight = Math.ceil(
      Math.max(...headerCells.filter((x) => !x.classList.contains('swiper-slide-duplicate')).map((x) => x.offsetHeight))
    )

    headerCells.forEach((x) => (x.style.height = `${maxHeaderHeight}px`))
    headerNode.classList.remove('invisible')
  },

  handleControls: () => {
    const controls = document.querySelector('.comparison-controls')

    setTimeout(() => {
      if (mainSwiper.visibleSlides.length === numSlides) {
        controls.classList.add('hidden')
        mainSwiper.loop = false
        mainSwiper.enabled = false
      } else {
        controls.classList.remove('hidden')
        controls.classList.remove('invisible')
        mainSwiper.enabled = true
      }
    }, 16)
  },
}

export default {
  can: () => headerNode && gridNode,
  run: fn.init,
}
